import { getPaidPriceInCents } from "../lib/paid-price.lib";
import type { OrderLineItem } from "../types";
import { parseLineItemPriceInCents } from "./get-line-item-price";

export type LineItemDisplay = {
  title: string;
  subtitle: string | null;
  image: string | null;
  /** Catalog unit price in cents, or null if unavailable/unparseable. */
  price: number | null;
  /** Unit price actually paid, in cents. */
  paidPrice: number;
  sku: string | null;
};

export function getLineItemDisplay(
  lineItems: OrderLineItem[],
  lineItemId: string,
): LineItemDisplay {
  const item = lineItems.find((li) => li.line_item_id === lineItemId);
  if (!item) {
    return {
      title: lineItemId,
      subtitle: null,
      image: null,
      price: null,
      paidPrice: 0,
      sku: null,
    };
  }

  const options = [
    item.variant.option1,
    item.variant.option2,
    item.variant.option3,
  ]
    .filter(Boolean)
    .join(" / ");

  return {
    title: item.title,
    subtitle: options || null,
    image: item.image ?? null,
    price: parseLineItemPriceInCents(item.price),
    paidPrice: getPaidPriceInCents(item),
    sku: item.sku ?? null,
  };
}
